import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";

/** The choices next-themes accepts (app/providers.tsx). Labels: t(`themes.${value}`). */
export const THEMES = [
  { value: "light", icon: SunIcon },
  { value: "dark", icon: MoonIcon },
  { value: "system", icon: MonitorIcon },
] as const;

export type ThemeValue = (typeof THEMES)[number]["value"];
